import React, { useEffect, useState } from 'react';
import StudentsContainer from './Students/StudentsContainer';
import TrackingContainer from './TrackingContainer';
import BarcodeExporter from '../containers/BarcodeExporter';
import AdminTab from '../containers/AdminTab';
import StudentImporter from '../containers/StudentImporter';
import { useStudentsActions } from '../contexts/StudentsContext';

const HomeContent = () => {
  const selectedCss = 'bg-blue-50 border-b border-l-gray-100 border-b-blue-500 border-b-4';
  const [selectedTab, setSelectedTab] = useState(0);

  const { getAllStudents } = useStudentsActions();

  useEffect(() => {
    getAllStudents();
  }, []);

  const getPageFromTab = () => {
    if (selectedTab === 0) {
      return <StudentsContainer />;
    } else if (selectedTab === 1) {
      return <TrackingContainer />;
    } else if (selectedTab === 2) {
      return <BarcodeExporter />;
    } else if (selectedTab === 3) {
      return <StudentImporter />;
    } else {
      return <AdminTab />;
    }
  };

  const tabComponent = (name: string, description: string, icon: JSX.Element, i: number) => (
    <div
      className={`flex px-8 py-5 cursor-pointer text-gray-900 items-center hover:bg-gray-100 ${selectedTab === i ? selectedCss : ''}`}
      onClick={() => setSelectedTab(i)}
    >
      {icon}
      <div className="ml-3">
        <div className="font-medium leading-6 text-gray-600">{name}</div>
        <div className="mt-0.5 text-sm text-gray-500">{description}</div>
      </div>
    </div>
  );
  return (
    <main className="py-6 px-12 space-y-12 bg-gray-100 min-h-screen w-full">
      <section className="grid grid-cols-5 bg-white divide-x w-full rounded-lg">
        {tabComponent(
          'Students',
          'View, edit and delete students in the system.',
          <svg
            className="text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -960 960 960"
            width="48px"
            fill="#5f6368"
          >
            <path d="M212-241v-339h60v339h-60Zm242 0v-339h60v339h-60ZM80-121v-60h800v60H80Zm608-120v-339h60v339h-60ZM80-640v-53l400-228 400 228v53H80Zm134-60h532-532Zm0 0h532L480-852 214-700Z" />
          </svg>,
          0,
        )}
        {tabComponent(
          'Tracking',
          'Track current students in the centre.',
          <svg
            className="text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -960 960 960"
            width="48px"
            fill="#5f6368"
          >
            <path d="M480.09-490q28.91 0 49.41-20.59 20.5-20.59 20.5-49.5t-20.59-49.41q-20.59-20.5-49.5-20.5t-49.41 20.59q-20.5 20.59-20.5 49.5t20.59 49.41q20.59 20.5 49.5 20.5ZM480-159q133-121 196.5-219.5T740-552q0-117.79-75.29-192.9Q589.42-820 480-820t-184.71 75.1Q220-669.79 220-552q0 75 65 173.5T480-159Zm0 79Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
          </svg>,
          1,
        )}
        {tabComponent(
          'Barcodes',
          'Export barcodes for printing',
          <svg
            className="text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -960 960 960"
            width="48px"
            fill="#5f6368"
          >
            <path d="M40-200v-560h80v560H40Zm120 0v-560h80v560h-80Zm120 0v-560h40v560h-40Zm120 0v-560h80v560h-80Zm120 0v-560h120v560H520Zm160 0v-560h40v560h-40Zm120 0v-560h120v560H800Z" />
          </svg>,
          2,
        )}
        {tabComponent(
          'Student Importer',
          'Import many students at once',
          <svg
            className="text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -960 960 960"
            width="48px"
            fill="#5f6368"
          >
            <path d="M440-320v-326L336-542l-56-58 200-200 200 200-56 58-104-104v326h-80ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
          </svg>,
          3,
        )}
        {tabComponent(
          'Admin',
          'Access settings and download logs',
          <svg
            className="text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -960 960 960"
            width="48px"
            fill="#5f6368"
          >
            <path d="M680-280q25 0 42.5-17.5T740-340q0-25-17.5-42.5T680-400q-25 0-42.5 17.5T620-340q0 25 17.5 42.5T680-280Zm0 120q31 0 57-14.5t42-38.5q-22-13-47-20t-52-7q-27 0-52 7t-47 20q16 24 42 38.5t57 14.5ZM480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v227q-19-8-39-14.5t-41-9.5v-147l-240-90-240 90v188q0 47 12.5 94t35 89.5Q310-290 342-254t71 60q11 32 29 61t41 52q-1 0-1.5.5t-1.5.5Zm200 0q-83 0-141.5-58.5T480-280q0-83 58.5-141.5T680-480q83 0 141.5 58.5T880-280q0 83-58.5 141.5T680-80ZM480-494Z" />
          </svg>,
          4,
        )}
      </section>
      <div className="flex flex-col h-full w-full mx-auto  space-y-6">{getPageFromTab()}</div>
    </main>
  );
};

export default HomeContent;
